export const CLAIM_FORM_ROUTE_NAME = "forms";

export function openClaimForm(router, uuid) {
  return router.push(`/form/${uuid}`).catch(() => {});
}
